import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import PpiIadSvc from "@/services/PpiIadService";

@Module({
  store,
  dynamic: true,
  namespaced: true,
  name: "ppi-iad"
})
class PpiIadModule extends VuexModule {
  list: any[] = [];
  currentItem: any = null;
  loading = false;

  @Mutation SET_LIST(val: any[]) {
    this.list = val || [];
  }

  @Mutation SET_CURRENT_ITEM(val: any) {
    this.currentItem = val;
  }

  @Mutation SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Action async getByRegister(reg: string | number) {
    this.SET_LOADING(true);
    try {
      const dt = await PpiIadSvc.getByRegister(reg);
      const { data } = dt.data;
      this.SET_LIST(Array.isArray(data) ? data : []);
    } catch {
      this.SET_LIST([]);
    }
    this.SET_LOADING(false);
  }

  @Action async refresh(id: number) {
    this.SET_LOADING(true);
    try {
      const dt = await PpiIadSvc.find(id);
      const { data } = dt.data;
      this.SET_CURRENT_ITEM(data || null);
    } catch {
      this.SET_CURRENT_ITEM(null);
    }
    this.SET_LOADING(false);
  }

  @Action select(item: any) {
    this.SET_CURRENT_ITEM(item || null);
  }

  @Action reset() {
    this.SET_LIST([]);
    this.SET_CURRENT_ITEM(null);
  }
}

export const storePpiIad = getModule(PpiIadModule);
